import {fetchMe} from './me'

export const LOGIN_IN_PROGRESS = 'controller-tool/loginStatus/login-in-progress'
export const LOGIN_SUCCESS = 'controller-tool/loginStatus/login-success'
export const LOGIN_FAILED = 'controller-tool/loginStatus/login-failed'
export const LOGIN_LOGGED_OUT = 'controller-tool/loginStatus/login-logged-out'

export default function reducer(state = 'pending', action = {}) {
  switch (action.type) {
    case LOGIN_IN_PROGRESS:
      return 'login-in-progress'
      break

    case LOGIN_SUCCESS:
      return 'login-success'
      break

    case LOGIN_LOGGED_OUT:
      return 'logged-out'
      break

    case LOGIN_FAILED:
      return 'login-failed'
      break

    default:
      return state
      break
  }
}

export function loginInProgress() {
  return { type: LOGIN_IN_PROGRESS }
}

export function loginSuccess() {
 return { type: LOGIN_SUCCESS }
}

export function loginFailed() {
  return { type: LOGIN_FAILED }
}

export function loginLoggedOut() {
  return { type: LOGIN_LOGGED_OUT }
}



// WEBPACK FOOTER //
// ./ducks/authStatus.js